import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { TopbarComponent } from './topbar.component';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    NgbModule
  ],
  declarations: [
    TopbarComponent
  ],
  exports: [
    TopbarComponent
  ]
})
export class TopbarModule { }
